import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoCredit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 214,
	height: 148,
	viewBox: "0 0 214 148",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 214,
			height: 148,
			fill: "#F8F9FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.957 117.445H201.046",
			stroke: "#C2C9D6",
			strokeWidth: 1.51833
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.957 90.043H201.046",
			stroke: "#C2C9D6",
			strokeWidth: 1.51833
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.957 62.6445H201.046",
			stroke: "#C2C9D6",
			strokeWidth: 1.51833
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.957 35.2461H201.046",
			stroke: "#C2C9D6",
			strokeWidth: 1.51833
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.332 137.319V10.6875",
			stroke: "#C2C9D6",
			strokeWidth: 1.51833
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M134.68 137.319V10.6875",
			stroke: "#C2C9D6",
			strokeWidth: 1.51833
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M162.023 137.319V10.6875",
			stroke: "#C2C9D6",
			strokeWidth: 1.51833
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M189.371 137.319V10.6875",
			stroke: "#C2C9D6",
			strokeWidth: 1.51833
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.9883 137.319V10.6875",
			stroke: "#C2C9D6",
			strokeWidth: 1.51833
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.6445 137.319V10.6875",
			stroke: "#C2C9D6",
			strokeWidth: 1.51833
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.2969 137.319V10.6875",
			stroke: "#C2C9D6",
			strokeWidth: 1.51833
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 214,
			height: 148,
			fill: "url(#paint0_linear_10780_48170)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M109 76.0738C110.319 74.7405 112.069 74.0043 113.944 74.0043C114.166 74.0043 114.375 74.046 114.597 74.0738L114.916 71.2821C114.597 71.2543 114.277 71.2266 113.958 71.2266C109.388 71.2266 105.569 74.3932 104.527 78.6432L107.25 79.2682C107.541 78.0738 108.125 76.9766 109.013 76.0738H109Z",
			fill: "#667799"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M113.946 68.4457C120.835 68.4457 126.446 74.0569 126.446 80.9457C126.446 87.8346 120.835 93.4457 113.946 93.4457C107.057 93.4457 101.446 87.8346 101.446 80.9457C101.446 74.0569 107.057 68.4457 113.946 68.4457ZM113.946 65.668C105.501 65.668 98.668 72.5013 98.668 80.9457C98.668 89.3902 105.501 96.2235 113.946 96.2235C122.39 96.2235 129.224 89.3902 129.224 80.9457C129.224 72.5152 122.376 65.6819 113.946 65.668Z",
			fill: "#667799"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M122.857 77.1133L120.288 78.2105C120.663 79.0577 120.871 79.9744 120.885 80.9466C120.885 84.7661 117.774 87.8911 113.941 87.8911H113.843C112.01 87.8633 110.316 87.0716 109.079 85.8216L107.121 87.7938C108.857 89.5299 111.232 90.6272 113.802 90.6688C113.843 90.6688 113.899 90.6688 113.941 90.6688C119.302 90.6688 123.663 86.3077 123.663 80.9466C123.663 79.5855 123.371 78.2938 122.857 77.1133Z",
			fill: "#667799"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.0087 78.8542C94.217 78.2431 92.5226 77.2431 91.1059 75.7987C86.2865 70.8681 86.3698 62.9376 91.3004 58.1181C96.2309 53.2987 104.161 53.382 108.981 58.3126C110.328 59.6876 111.273 61.2987 111.856 63.0209C112.536 62.9376 113.231 62.8959 113.939 62.8959C114.217 62.8959 114.481 62.9237 114.745 62.9376C114.078 60.5487 112.828 58.2848 110.967 56.382C105.064 50.3542 95.3976 50.2431 89.3559 56.1459C83.3142 62.0487 83.217 71.7154 89.1198 77.757C91.0642 79.7431 93.4254 81.0348 95.9115 81.7292C95.9115 81.4654 95.8698 81.2154 95.8698 80.9515C95.8698 80.2431 95.9254 79.5487 95.9948 78.8542H96.0087Z",
			fill: "#4E86F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95.1898 62.0957L95.2592 62.0262C96.5787 60.7624 98.3564 60.1512 100.12 60.1651V57.3874C97.6759 57.3596 95.2176 58.2346 93.3564 60.0124C93.3148 60.0401 93.287 60.0818 93.2453 60.1096C90.8703 62.429 89.9398 65.679 90.4676 68.7346L93.2037 68.2346C92.8426 66.0679 93.4953 63.7624 95.1898 62.1096V62.0957Z",
			fill: "#4E86F3"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_10780_48170",
			x1: 10.4185,
			y1: 74,
			x2: 204.138,
			y2: 74,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#F8F9FA" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .493625,
					stopColor: "#F8F9FA",
					stopOpacity: .85
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#F8F9FA"
				})
			]
		}) })
	]
});
export default SvgNoCredit;
